import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

const Achievements = () => {
  const [count, setCount] = useState({
    world: 0,
    europe: 0,
    georgia: 0,
    total: 0,
  });
  const { t } = useTranslation();

  useEffect(() => {
    const targetCounts = { world: 11, europe: 22, georgia: 48 };
    targetCounts.total = Object.values(targetCounts).reduce(
      (sum, val) => sum + val,
      0
    );
    const duration = 3000;
    const stepTime = Math.abs(Math.floor(duration / targetCounts.total));
    const interval = setInterval(() => {
      setCount((prevCount) => {
        const newCount = {
          world: Math.min(prevCount.world + 1, targetCounts.world),
          europe: Math.min(prevCount.europe + 1, targetCounts.europe),
          georgia: Math.min(prevCount.georgia + 1, targetCounts.georgia),
          total: Math.min(prevCount.total + 1, targetCounts.total),
        };
        if (newCount.total === targetCounts.total) {
          clearInterval(interval);
        }
        return newCount;
      });
    }, stepTime);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative z-0 p-6 overflow-hidden bg-baseBlue">
      {/* Shadow effect at the top */}
      {/* owEffect /> */}
      <div className="relative flex flex-col gap-6 md:gap-10 py-14 z-10 text-white">
        <div className="text-2xl md:text-4xl font-extrabold text-center">
          {t("OurClubsAchievements")}
        </div>
        <div className="text-sm md:text-lg text-center max-w-[800px] mx-auto">
          {t("achievementsText")}
        </div>
        <div className="text-sm font-bold md:text-lg text-center max-w-[800px] mx-auto">
          Gold Medal Records
        </div>
        <div className="flex flex-wrap justify-evenly text-xl md:text-2xl text-white font-extrabold text-center gap-8 md:gap-16">
          <div className="flex flex-col items-center gap-2 md:gap-3 w-16">
            <div className="text-4xl md:text-6xl ">{count.world}</div>
            <div className="h-1 w-full bg-baseGreen rounded"></div>
            <div>{t("world")}</div>
          </div>
          <div className="flex flex-col items-center gap-2 md:gap-3 w-16">
            <div className="text-4xl md:text-6xl ">{count.europe}</div>
            <div className="h-1 w-full bg-baseGreen rounded"></div>
            <div>{t("europe")}</div>
          </div>
          <div className="flex flex-col items-center gap-2 md:gap-3 w-16">
            <div className="text-4xl md:text-6xl ">{count.georgia}</div>
            <div className="h-1 w-full bg-baseGreen rounded"></div>
            <div>{t("georgia")}</div>
          </div>
          <div className="flex flex-col items-center gap-2 md:gap-3 w-16">
            <div className="text-4xl md:text-6xl ">{count.total}</div>
            <div className="h-1 w-full bg-baseGreen rounded"></div>
            <div>{t("total")}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Achievements;
